import { render, staticRenderFns } from "./CBoxButtonGroup.vue?vue&type=template&id=60e31c64&scoped=true&"
import script from "./CBoxButtonGroup.vue?vue&type=script&lang=js&"
export * from "./CBoxButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./CBoxButtonGroup.vue?vue&type=style&index=0&id=60e31c64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e31c64",
  null
  
)

export default component.exports